import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Dialog, DialogContent } from '../../UI/Modal/ModalPrimitive'
import FbButton, { FbButtonVariants } from '../../FbUI/FbButton'
import { ContactRequestProvider } from './ContactRequestContext'
import { StepManager } from './components/StepManager'

interface ContactRequestJobFromCampaignModalProps {
  campaignId: number
  buttonText?: string
  variant?: FbButtonVariants
  onContactRequested?: () => void
  disabled?: boolean
  disabledTooltipText?: string
}

export const ContactRequestJobFromCampaignModal: React.FC<
  ContactRequestJobFromCampaignModalProps
> = ({
  campaignId,
  buttonText = 'Request Contacts',
  variant = 'primary',
  onContactRequested,
  disabled = false,
  disabledTooltipText,
}) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    if (!disabled) {
      setOpen(true)
    }
  }
  const handleClose = () => setOpen(false)

  const button = (
    <FbButton variant={variant} onClick={handleOpen} disabled={disabled}>
      {buttonText}
    </FbButton>
  )

  return (
    <>
      {disabled && disabledTooltipText ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-request-contacts-disabled">
              {disabledTooltipText}
            </Tooltip>
          }
        >
          <div>{button}</div>
        </OverlayTrigger>
      ) : (
        button
      )}

      <Dialog open={open} onOpenChange={(open) => !open && handleClose()}>
        <DialogContent id={'fb-modal-content'} size="2xl">
          <ContactRequestProvider
            campaignId={campaignId}
            handleClose={handleClose}
            onContactRequested={onContactRequested}
          >
            <StepManager />
          </ContactRequestProvider>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ContactRequestJobFromCampaignModal
